module.exports = __webpack_public_path__ + "img/moldova.4c5d66cf.svg";